import { V2WaterFlowConfigTreePostResponse } from '@maxtropy/device-customer-apis-v2';
type RawTreeNode = NonNullable<V2WaterFlowConfigTreePostResponse['tree']>[number];
export interface DeviceTypes {
  id: number;
  name: string;
  children?: Array<DeviceTypes>;
  deviceTypes?: Array<DeviceTypes>;
}

export interface DeviceTypeTree {
  aliasName: Array<string>;
  tree: Array<DeviceTypes>;
}
export interface CascadingMultipleData {
  label?: string;
  value?: number;
  child: Array<CascadingMultipleData> | undefined;
}

export function formatOptionData(response: DeviceTypeTree | undefined): Array<CascadingMultipleData> | undefined {
  const loop = (data: Array<DeviceTypes>): Array<CascadingMultipleData> => {
    return data.map(item => ({
      label: item.name,
      value: item.id,
      child: item.deviceTypes || item.children ? loop(item.deviceTypes || item.children!) : undefined,
    }));
  };
  if (!response) return undefined;
  return loop(response.tree);
}

export const adaptToDeviceTypeTree = (res: V2WaterFlowConfigTreePostResponse): DeviceTypeTree => {
  if (!res.tree) return { tree: [], aliasName: res.aliasName! };
  const transformNode = (node: any): DeviceTypes => {
    const rawSource = node.deviceTypes || node.children;
    const rawList = Array.isArray(rawSource) ? rawSource : [];

    const transformedChildren = rawList.map(transformNode);
    return {
      id: node.id,
      name: node.name,
      children: transformedChildren,
      deviceTypes: transformedChildren,
    };
  };

  return {
    tree: res.tree.map(transformNode),
    aliasName: res.aliasName!,
  };
};

export const getLastChildrenIds = (sourceData: DeviceTypes[]): number[] => {
  let ids: number[] = [];

  const loop = (data: DeviceTypes[]) => {
    if (!data || data.length === 0) return;

    data.forEach(item => {
      if (item.children && item.children.length !== 0) {
        loop(item.children);
      } else {
        // 是叶子节点，收集 ID
        ids.push(item.id);
      }
    });
  };

  loop(sourceData);
  return ids;
};

export const getChildNodesByParentIds = (treeData?: number[] | number[][], sourceData?: DeviceTypes[]): number[] => {
  if (!treeData || !sourceData || sourceData.length === 0) return [];
  const ids: number[] = [];
  const targetPaths =
    Array.isArray(treeData) && Array.isArray(treeData[0]) ? (treeData as number[][]) : [treeData as number[]];
  targetPaths.forEach(path => {
    if (!Array.isArray(path) || path.length === 0) return;
    const targetId = path[path.length - 1];
    const findNodeAndCollectLeaves = (nodes: DeviceTypes[]): boolean => {
      for (const node of nodes) {
        if (node.id === targetId) {
          if (node.children && node.children.length > 0) {
            ids.push(...getLastChildrenIds(node.children));
          } else {
            ids.push(node.id);
          }
          return true;
        }
        if (node.children && node.children.length > 0) {
          if (findNodeAndCollectLeaves(node.children)) {
            return true;
          }
        }
      }
      return false;
    };
    findNodeAndCollectLeaves(sourceData);
  });

  return ids;
};
